/**
 * declension of numerical values
 *
 * morph(count, ['задача', 'задачи', 'задач']);
 */
const morph = (count: number, array: string[]): string => {
  const cases = [2, 0, 1, 1, 1, 2]
  const cond = count % 100 > 4 && count % 100 < 20
  const index = cond ? 2 : cases[count % 10 < 5 ? count % 10 : 5] || 1

  return array[index] || ''
}

export const multiActionsWithTasksEn = {
  selectMultipleTasks: 'Select multiple',
  allocatedTasks: (count: number) => `Allocated: ${count}`,
  fromArchive: (count: number) => `from the archive ${count}`,
  noRightsToSomeTasks: 'You do not have rights to some of the selected tasks',
  performActionOnAvailable: 'Perform an action on the available',
  cancel: 'Cancel',
  selectedTasks: (val: number) =>
    `Selected ${val} ${morph(val, ['task', 'tasks', 'tasks'])}`,
  deleteSelectedTasks: (val: number) => `Delete selected ${val} tasks?`,
  applyCustomStickerState: (sticker: string, state: string, tasks: number) =>
    `Apply “${state}” of the “${sticker}” sticker to ${tasks} tasks? For tasks without this sticker, it will be created.`,
  yesDelete: 'Yes, delete',
  yesDelete2: 'Delete message',
  yesConfirm: 'Yes, confirm',
  confirm: 'Confirm',
  changeAssignees: 'Change Assignees',
  exit: 'Are you sure you want to exit the multi selector?',
  noPermissionDelete:
    'You do not have permission to delete some of the selected tasks',
  noPermissionsComplete:
    'You do not have permission to complete some of the selected tasks',
  noPermissionsArchive:
    'You do not have permission to archive some of the selected tasks',
  noPermissionsMove:
    'You do not have permission to move some of the selected tasks',
  noPermissionsUnarchive:
    'You do not have rights to return some selected tasks from the archive',
  noPermissionsUncheck:
    'You do not have rights to cancel execution of some of the selected tasks',
  deleteOnlyAvailable: 'Delete only available',
  completeOnlyAvailable: 'Complete only available',
  archiveOnlyAvailable: 'Archive only available',
  moveOnlyAvailable: 'Move only available',
  unarchiveOnlyAvailable: 'Unarchive only available',
  uncheckOnlyAvailable: 'Uncheck only available',
  withoutPermissionsDelete:
    'You do not have sufficient rights to delete tasks. Please contact your company administrator',
  withoutPermissionsArchive:
    'You do not have sufficient rights to archive tasks. Please contact your company administrator',
  withoutPermissionsRestore:
    'You do not have sufficient rights to restore tasks from the archive. Please contact your company administrator',
  withoutPermissionsComplete:
    'You do not have sufficient rights to complete the tasks. Please contact your company administrator',
  withoutPermissionUncomplete:
    'You do not have enough permissions to uncheck tasks for completion. Please contact your company administrator',
  withoutPermissionsMove:
    'You do not have sufficient rights to move tasks. Please contact your company administrator',
  noDragTask:
    'You can not drag tasks by dragging a task in dashboard column or a subtask (we solve this). Drag by picking up a regular task.'
}

export const multiActionsWithTasksRu: typeof multiActionsWithTasksEn = {
  selectMultipleTasks: 'Выделить несколько',
  allocatedTasks: (count: number) => `Выделено: ${count}`,
  fromArchive: (count: number) => `из архива ${count}`,
  noRightsToSomeTasks: 'У вас нет прав на часть выбранных задач',
  performActionOnAvailable: 'Провести действие над доступными',
  cancel: 'Отменить',
  selectedTasks: (val: number) =>
    `${morph(val, ['Выбранная', 'Выбранные', 'Выбранные'])} ${val} ${morph(
      val,
      ['задача', 'задачи', 'задач']
    )}`,
  deleteSelectedTasks: (val: number) => {
    if (val === 1) {
      return `Удалить выделенную задачу?`
    }
    if (val >= 2 && val <= 4) {
      return `Удалить выделенные ${val} задачи?`
    }

    return `Удалить выделенные ${val} задач?`
  },
  applyCustomStickerState: (sticker: string, state: string, tasks: number) =>
    `Применить состояние “${state}” стикера “${sticker}” к ${tasks} задачам? У задач без этого стикера он будет создан.`,
  yesDelete: 'Да, удалить',
  yesDelete2: 'Удалить сообщение',
  yesConfirm: 'Да, применить',
  confirm: 'Применить',
  changeAssignees: 'Изменить исполнителей',
  exit: 'Вы уверены, что хотите выйти из мультиселектора?',
  noPermissionDelete: 'У вас нет прав удалить часть выбранных задач',
  noPermissionsComplete: 'У вас нет прав выполнить часть выбранных задач',
  noPermissionsArchive: 'У вас нет прав архивировать часть выбранных задач',
  noPermissionsMove: 'У вас нет прав переместить часть выбранных задач',
  noPermissionsUnarchive:
    'У вас нет прав вернуть из архива часть выбранных задач',
  noPermissionsUncheck:
    'У вас нет прав отменить выполнение у части выбранных задач',
  deleteOnlyAvailable: 'Удалить только доступные',
  completeOnlyAvailable: 'Выполнить только доступные',
  archiveOnlyAvailable: 'Архивировать только доступные',
  moveOnlyAvailable: 'Переместить только доступные',
  unarchiveOnlyAvailable: 'Вернуть из архива только доступные',
  uncheckOnlyAvailable: 'Пометить как не выполненные только доступные',
  withoutPermissionsDelete:
    'У вас недостаточно прав для удаления задач. Обратитесь к администратору вашей компании',
  withoutPermissionsArchive:
    'У вас недостаточно прав для архивации задач. Обратитесь к администратору вашей компании',
  withoutPermissionsRestore:
    'У вас недостаточно прав для восстановления задач из архива. Обратитесь к администратору вашей компании',
  withoutPermissionsComplete:
    'У вас недостаточно прав для выполнения задач. Обратитесь к администратору вашей компании',
  withoutPermissionUncomplete:
    'У вас недостаточно прав снятия признака выполнения с задач. Обратитесь к администратору вашей компании',
  withoutPermissionsMove:
    'У вас недостаточно прав для перемещения задач. Обратитесь к администратору вашей компании',
  noDragTask:
    'Нельзя перетащить задачи, взявшись за задачу в сводке или подзадачу (решаем это). Перетащите, взявшись за обычную задачу.'
}
